import { generateTestId } from "@client-shared";

export const setInventoryTableTestId = (identifier: string): string => generateTestId("InventoryTable", identifier);

// Table Headers
export const setInventoryTableHeaderTestId = (column: string): string => generateTestId("InventoryTable", `header-${column}`);

// Table Rows
export const setInventoryTableRowTestId = (id: string | number): string => generateTestId("InventoryTable", `row-${id}`);

// Status Badges
export const setInventoryTableStatusBadgeTestId = (status: string): string => generateTestId("InventoryTable", `status-${status}`);

// Row Actions
export const setInventoryTableActionTestId = (id: string | number, action: string): string =>
  generateTestId("InventoryTable", `action-${action}-${id}`);
